import {
  all,
  put,
  takeEvery,
}                           from 'redux-saga/effects';
import { buildShowActions } from '../actions/utils/apiResources/buildSyncActions';
import { resourceNames }    from '../config/resources.config';
import { loginSuccess }     from '../modules/auth/actions/login';


export function* authSagas() {

  yield all([
    watchLogin(),
  ]);

}

/**
 * Sets up watchers on login success
 */
export function* watchLogin() {

  yield all([
    takeEvery(loginSuccess, loadCurrentUser),
    takeEvery(loginSuccess, loadCurrentUserCapabilities),
  ]);

}

export function* loadCurrentUser({payload: {jwt}}) {

  yield put(
    buildShowActions(resourceNames.USERS).request({url: jwt.userId}),
  );
}

export function* loadCurrentUserCapabilities({payload: {jwt}}) {

  yield put(
    buildShowActions(resourceNames.USERS).request({url: `${jwt.userId}/capabilities`}),
  );

}


// WEBPACK FOOTER //
// ./src/sagas/auth.js